@import "../../global/gx-ide-mixins.scss";
@import "../../global/gx-ide-common.scss";
@import "../../global/temporary-mercury-overrides/_button.scss";
@import "../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss";

:host {
  display: grid;
  block-size: 100%;
  overflow: auto;
  grid-template-rows: max-content 1fr max-content;
}

.section {
  display: contents;
}

// - - - - - - - - - - - - -
// Header
// - - - - - - - - - - - - -

.header {
  display: grid;
  grid-auto-rows: max-content;
  // 88px is the inline-size of the largest label (Access Token) that is not always visible.
  // Setting 88px as the minimum inline size prevents an undesired difference when Access Token
  // is visible. This fix has been made for english only. The value should work with .ja and .zh also.
  grid-template-columns: minmax(88px, max-content) 1fr !important;

  &--show-access-token {
    grid-template-areas:
      "path-url-label path-url-wrapper"
      "access-token-label access-token"
      "style-label style"
      "module-label module"
      "checkboxes-options checkboxes-options";
  }
  &--hide-access-token {
    grid-template-areas:
      "path-url-label path-url-wrapper"
      "style-label style"
      "module-label module"
      "checkboxes-options checkboxes-options";
  }
}
// path url
.path-url-wrapper {
  grid-template-columns: 1fr max-content;
}
.path-url-label {
  grid-area: path-url-label;
}
.path-url-control {
  flex-grow: 1;
}
.select-load-button {
  min-inline-size: 80px;
}
// access token
.access-token-label {
  grid-area: access-token-label;
}
.access-token {
  grid-area: access-token;
}
// style
.style-label {
  grid-area: style-label;
}
.style {
  grid-area: style;
}
// module
.module-label {
  grid-area: module-label;
}
.module {
  grid-area: module;
}
// checkboxes options
.checkboxes-options {
  grid-area: checkboxes-options;
  grid-template-columns: max-content max-content;
  justify-content: space-between;
}

// - - - - - - - - - - - - -
// Main
// - - - - - - - - - - - - -

.main {
  display: grid;
  grid-template-columns: 250px 1fr;
  block-size: 100%;
  overflow: auto;

  &--loading {
    grid-template-columns: 1fr;
  }
}

.panel-tab {
  block-size: 100%;
  display: grid;
  grid-template-columns: 1fr 300px;

  .panel-item {
    overflow: auto;
  }
}
.panel-tab:has(> :only-child) {
  grid-template-columns: 1fr;
}

.tree-view {
  padding-block: 4px;
}

.tree-view-panel-item {
  border-inline-start: var(--section-common-border);
}

.checker-board {
  --white-square-color: #fff1;
  --black-square-color: #0000;
  background:
    linear-gradient(
      45deg,
      var(--white-square-color) 25%,
      var(--black-square-color) 25%
    ),
    linear-gradient(
      -45deg,
      var(--white-square-color) 25%,
      var(--black-square-color) 25%
    ),
    linear-gradient(
      45deg,
      var(--black-square-color) 75%,
      var(--white-square-color) 75%
    ),
    linear-gradient(
      -45deg,
      var(--black-square-color) 75%,
      var(--white-square-color) 75%
    );
  background-size: 20px 20px;
  background-position:
    0 0,
    0 10px,
    10px -10px,
    -10px 0px;
}

/*--- Tabs ---*/
.tab {
  border-width: 0 !important; // WA/TODO this should be a class on mercury
}
.tab.fit-images .composition-tab-slot {
  font-size: 0; // WA to prevent scroll
}
.tab.fit-images img {
  object-fit: scale-down;
  object-position: left top;
  max-height: 100%;
}
.tab--hidden {
  display: none;
}

// - - - - - - - - - - - - -
// Footer
// - - - - - - - - - - - - -

.button-cancel,
.button-ok {
  min-inline-size: 64px;
}

// - - - - - - - - - - - - -
// Other
// - - - - - - - - - - - - -

.messages-slot-container {
  block-size: 100%;
}

.composition-tab-slot {
  block-size: 100%;
  overflow: auto;
}

.empty-state {
  overflow: auto;
}
.empty-state-button {
  // WA (It looks more pleasing with a little bit less of gap)
  transform: translateY(-12px);
}

// Messages Styles
.messages-container {
}
.message {
  animation: fadeIn var(--timing-fast) ease-in-out forwards;

  &--info {
    color: var(--color-text-neutral-strawberry);
  }
  &--warning {
    color: var(--color-text-warning-default);
  }
  &--error {
    color: var(--color-text-error-default);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
